module.exports = __webpack_public_path__ + "static/media/29-web-or-mls-DSC06727.70ea49a1.jpg";